import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=8e4a1738&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4a1738",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e4a1738')) {
      api.createRecord('8e4a1738', component.options)
    } else {
      api.reload('8e4a1738', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=8e4a1738&scoped=true&", function () {
      api.rerender('8e4a1738', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Fm10JsXDBPAW/JS/comp/Accordion.vue"
export default component.exports